import Component from '../Component';

export default class QuickAdd extends Component {
  constructor(theme, element) {
    super(theme, element);

    this.theme = theme;
    this.element = element;
    this.onSubmit = this.onSubmit.bind(this);
    this.isProcessing = false;
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.cartType = document.getElementById('PageContainer').dataset.cartType;
    this.languageUrl = document.getElementById('PageContainer').dataset.languageUrl;
    this.formWrappers = /** @type {NodeListOf<HTMLElement>} */ (this.element.querySelectorAll('.quick-add-wrapper.is-singular'));
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);

    if (!this.formWrappers.length) {
      return;
    }

    this.formWrappers.forEach((wrapper) => {
      const form = wrapper.querySelector('.shopify-product-form');
      if (form && !form.hasAttribute('data-quick-add-initialized')) {
        form.addEventListener('submit', this.onSubmit);
        form.setAttribute('data-quick-add-initialized', 'true');
      }
    });
  }

  async onSubmit(e) {
    // Prevent duplicate submissions
    if (this.isProcessing) {
      e.preventDefault();
      return;
    }

    // Go straight to cart page, use html form submit event.
    if(this.cartType == 'page' && this.cartAction != 'show_added_message') {
      return;
    }

    e.preventDefault();
    this.isProcessing = true;

    const currentForm = e.currentTarget;
    const currentButton = currentForm.querySelector('[data-quick-add-button]');
    const productWrapper = currentForm.closest('.quick-add-wrapper.is-singular');

    // Store original button state for cleanup
    let previousInnerHTML = null;
    let isDesktopQuickAdd = false;

    try {
      if (!productWrapper) {
        console.error('Product wrapper not found.');
        return false;
      }

      // Retrieve liveRegion
      const liveRegion = currentForm.querySelector('.sr-only[aria-live="polite"]');
      
      isDesktopQuickAdd = currentButton.classList.contains('quick-add-button-desktop');

      // Loading spinner.
      if (isDesktopQuickAdd) {
        previousInnerHTML = currentButton.innerHTML;
        currentButton.classList.add('is-loading');
        currentButton.innerHTML = `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" class="spin flex-full"><g clip-path="url(#clip0_3605_47041)"><path d="M12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 15.1767 22.1534 18.0388 20 20.0468" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g><defs><clipPath id="clip0_3605_47041"><rect width="24" height="24" fill="none" transform="translate(0.5)"/></clipPath></defs>${ this.translationsObject.translations.loading }</svg>`;
      }

      const formData = new FormData(currentForm);
      const data = new URLSearchParams(formData).toString();
      const response = await window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data,
      });
      if (!response.ok) {
        // FIXME: error handling
        return false;
      }

      // Update cart drawer
      if(this.cartType == 'drawer') {
        const responseJson = await response.json();
        window.eventBus.emit('update:cart:drawer', responseJson);
      }

      const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
      const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
      if (!response2.ok) {
        // FIXME: error handling
        return false;
      }
      const cart = await response2.json();

      if(this.cartType == 'drawer' && this.cartAction == 'go_to_or_open_cart') {
        window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      }
      else {
        if (isDesktopQuickAdd) {
          currentButton.classList.remove('is-loading');
          currentButton.innerHTML = this.translationsObject.translations.productAdded;
        }
      }

      if (this.cartType == 'drawer') {
        const successMessage = productWrapper.getAttribute('data-product-added');
        if (liveRegion && successMessage) {
          liveRegion.textContent = successMessage;
        }
      }
      
      this.theme.updateCartCount(cart);

      if (isDesktopQuickAdd) {
        setTimeout(() => {
          const translationKey = currentButton.dataset.addToCartTranslationKey || 'addToCart';
          currentButton.classList.remove('is-loading');
          currentButton.innerHTML = this.translationsObject.translations[translationKey];
        }, 2000);
      }

    } catch (e) {
      console.error('Unable to add to cart: ', e);
      // FIXME error handling
    } finally {
      // Ensure button is always restored to a usable state on error
      if (currentButton && isDesktopQuickAdd && previousInnerHTML) {
        // Only restore if button still has the loading class (error path)
        if (currentButton.classList.contains('is-loading')) {
          currentButton.classList.remove('is-loading');
          currentButton.innerHTML = previousInnerHTML;
        }
      }
      this.isProcessing = false;
    }

    return false;
  }
}
